<template>
  <SinglePageLayout :content-size="contentSize">
    <template #titlebar>
      <AdvancedTitle
        v-if="session.user"
        :title="session.user.fullName || session.user.email"
        :subtitle="session.user.fullName ? session.user.email : session.user.id"
        pretitle="User"
      >
        <template #icon>
          <SessionUserAvatar style="--gp-avatar-size: 84px" />
        </template>
      </AdvancedTitle>
    </template>
    <template #tabbar>
      <Tabbar v-if="session.user">
        <TabbarItem
          :active="route === 'UserSettings'"
          :to="{ name: 'UserSettings' }"
          title="Settings"
        />
        <TabbarItem
          :active="route === 'UserBillingProfiles'"
          :to="{ name: 'UserBillingProfiles' }"
          title="Billing profiles"
        />
        <TabbarItem
          :active="route === 'UserSSHKeys'"
          :to="{ name: 'UserSSHKeys' }"
          title="SSH public keys"
        />
        <TabbarItem
          :active="route === 'UserClients'"
          :to="{ name: 'UserClients' }"
          title="OAuth clients"
        />
        <template #tabbarActions>
          <div class="tw-flex tw-gap-4">
            <slot name="buttons" />
          </div>
        </template>
      </Tabbar>
    </template>
    <template #content>
      <main v-if="session.user">
        <slot name="content" />
      </main>
    </template>
  </SinglePageLayout>
</template>

<script lang="ts">
import { useSessionStore } from 'gpcore-apikit/store/pinia/session';
import AdvancedTitle from 'gpcore-uikit/components/Component.AdvancedTitle.vue';
import TabbarItem from 'gpcore-uikit/components/Component.Tabbar.Item.vue';
import Tabbar from 'gpcore-uikit/components/Component.Tabbar.vue';
import Size from 'gpcore-uikit/interfaces/Size';
import { type PropType, computed } from 'vue';
import { useRoute } from 'vue-router';
import SessionUserAvatar from '@panel/components/app/SessionUserAvatar.vue';
import SinglePageLayout from './Layout.SinglePage.vue';

export default {
  components: {
    Tabbar,
    TabbarItem,
    AdvancedTitle,
    SinglePageLayout,
    SessionUserAvatar,
  },
  props: {
    contentSize: {
      type: Number as PropType<Size>,
      default: Size.Large,
    },
  },
  setup() {
    const route = useRoute();
    const sessionStore = useSessionStore();
    const session = computed(() => sessionStore.session);

    return {
      Size,
      route: route.name,
      session,
    };
  },
};
</script>
